import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'normalize.css';
import './index.scss';
import './utils/browserSupport.js';
import './utils/preloadFonts.js';


ReactDOM.render(<App />, document.getElementById('root'))
